import React from "react";
import Lottie from "lottie-react";
import noMasterFormLottie from "../../data/notFoundListLottie.json";

export function QuotationNotFound() {
  return (
    <section className="no-list-sec mt-3">
      <div className="row">
        <div className="col-md-12 my-auto">
          <div className="no-list d-flex align-items-center justify-content-center flex-column">
            <Lottie
              animationData={noMasterFormLottie}
              loop={true}
              autoplay={true}
              style={{ height: 174, width: 174 }}
            />
            <p>No quotation items available for forecasting.</p>
          </div>
        </div>
      </div>
    </section>
  );
}